import { GoIcon } from "@/components/icons";
import TitleHeader from "@/components/TitleHeader";
import { Flex, Text, useDisclosure, Image } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import CountryModal from "./CountryModal";
import { useUserInfo } from "@/context/UserInfo";
import ReceiveCurrencyModal from "./ReceiveCurrency";
import CURRENCY_MAP from "@/constants/currencys";
import TaxModal from "./TaxModal";
import { useState } from "react";

const Setting = () => {
  const navigate = useNavigate();
  const {
    isOpen: isOpenCountry,
    onOpen: onOpenCountry,
    onClose: onCloseCountry,
  } = useDisclosure();
  const {
    isOpen: isOpenReceiveCurrency,
    onOpen: onOpenReceiveCurrency,
    onClose: onCloseReceiveCurrency,
  } = useDisclosure();
  const {
    isOpen: isOpenTax,
    onOpen: onOpenTax,
    onClose: onCloseTax,
  } = useDisclosure();
  const { currencyInfo, countryInfo, taxRate, handleSetTaxRate } =
    useUserInfo();

  return (
    <Flex flexDir={"column"} sx={{ padding: "20px" }}>
      <TitleHeader
        color="#D8762B"
        title="Setting"
        onBack={() => navigate("/myInfo")}
      />
      <Text
        sx={{
          marginTop: "50px",
          color: "#333",
          fontSize: "20px",
          fontWeight: 500,
        }}
      >
        Country / State
      </Text>
      <Flex
        onClick={onOpenCountry}
        align={"center"}
        sx={{ marginTop: "20px" }}
        justify={"space-between"}
      >
        {countryInfo.countryName ? (
          <Flex align={"center"}>
            <Image
              src={`https://images-country.meld.io/${countryInfo.countryIsoCode}/flag.svg`}
              sx={{
                width: "30px",
                height: "30px",
                marginRight: "10px",
                borderRadius: "50%",
              }}
            ></Image>
            <Text>{countryInfo.countryName}</Text>
          </Flex>
        ) : (
          <Text
            sx={{
              color: "#BBB",
              fontSize: "14px",
              fontWeight: 500,
            }}
          >
            Select your country and state
          </Text>
        )}

        <GoIcon style={{ color: "#D8762B" }}></GoIcon>
      </Flex>
      <Text
        sx={{
          marginTop: "50px",
          color: "#333",
          fontSize: "20px",
          fontWeight: 500,
        }}
      >
        Currency
      </Text>
      <Flex
        align={"center"}
        sx={{ marginTop: "20px" }}
        justify={"space-between"}
        onClick={onOpenReceiveCurrency}
      >
        {currencyInfo.localCurrency ? (
          <Flex align={"center"}>
            <Image
              src={`https://images-country.meld.io/${
                CURRENCY_MAP[currencyInfo.localCurrency].countryCode
              }/flag.svg`}
              sx={{
                width: "30px",
                height: "30px",
                marginRight: "12px",
                borderRadius: "50%",
              }}
            ></Image>
            <Text
              sx={{
                marginRight: "15px",
              }}
            >
              {currencyInfo.localCurrency}
            </Text>
            <Text>{CURRENCY_MAP[currencyInfo.localCurrency].name}</Text>
          </Flex>
        ) : (
          <Text
            sx={{
              color: "#BBB",
              fontSize: "14px",
              fontWeight: 500,
            }}
          >
            Select your receive currency
          </Text>
        )}

        <GoIcon style={{ color: "#D8762B" }}></GoIcon>
      </Flex>
      <Text
        sx={{
          marginTop: "50px",
          color: "#333",
          fontSize: "20px",
          fontWeight: 500,
        }}
      >
        Tax
      </Text>
      <Flex
        align={"center"}
        sx={{ marginTop: "20px" }}
        justify={"space-between"}
        onClick={onOpenTax}
      >
        <Text
          sx={{
            color: "#333333",
            fontSize: "16px",
            fontWeight: 500,
          }}
        >
          {taxRate}%
        </Text>
        <GoIcon style={{ color: "#D8762B" }}></GoIcon>
      </Flex>
      <CountryModal isOpen={isOpenCountry} onClose={onCloseCountry} />
      <ReceiveCurrencyModal
        isOpen={isOpenReceiveCurrency}
        onClose={onCloseReceiveCurrency}
      />
      <TaxModal
        isOpen={isOpenTax}
        onClose={onCloseTax}
        taxValue={taxRate}
        handleSetTaxValue={handleSetTaxRate}
      />
    </Flex>
  );
};

export default Setting;
